import { useState } from "react";

import { ClickableIcon } from "components/Icon/ClickableIcon";
import { getConfig } from "utils/environment";

const banner = getConfig({
  dev: { label: "LOCALHOST", color: "#1565c0" },
  pr: { label: "PR ENV", color: "#6a1b9a" },
  staging: { label: "STAGING", color: "#2e7d32" },
  preprod: { label: "PREPROD", color: "#ef6c00" },
  prod: undefined,
});

export const EnvironmentBanner = () => {
  const [isClosed, setIsClosed] = useState(false);

  if (!banner || isClosed) return null;

  return (
    <div
      className="relative flex-center flex-none h-40 text-white font-bold tracking-widest"
      style={{ backgroundColor: banner.color }}
    >
      {banner.label}
      <ClickableIcon
        name="close"
        className="absolute right-12"
        onClick={() => setIsClosed(true)}
      />
    </div>
  );
};
